"use client";

import { ChatGuardrailsContainer, StaticBubble, Bubble } from "./ChatGuardrailsShared";

const STATES = ["IDLE", "HIDE_PLACEHOLDER", "AGENT_1_0", "AGENT_1_1", "USER_1_0", "AGENT_2_0", "AGENT_2_1", "SHOW_ALL"];

const AGENT_SPEAKING_STATES = ["AGENT_1_0", "AGENT_1_1", "AGENT_2_0", "AGENT_2_1"];

export function ChatGuardrailsMonitorPerformance() {
  return (
    <ChatGuardrailsContainer
      backgroundImage='/assets/images/backgrounds/coral-7-bg.png'
      avatarSrc='/assets/images/avatars/avatar_3.png'
      states={STATES}
      agentSpeakingStates={AGENT_SPEAKING_STATES}
    >
      {m => (
        <>
          <m.div
            className='tw-absolute tw-top-0 tw-inset-x-0'
            initial={{ opacity: 1 }}
            animate={{ HIDE_PLACEHOLDER: { opacity: 0 } }}
          >
            <StaticBubble sentences={["Hey, you've reached our Support Team.", "How can I help you?"]} />
            <StaticBubble
              sentences={[
                "I just got charged extra customs on your parcel – yesterday's order was fine. What changed?",
              ]}
              variant='user'
              className='tw-mt-2'
            />
            <StaticBubble
              sentences={[
                "I don't have up-to-date information on customs policies.",
                "Let me redirect you to a human agent who can look into this.",
              ]}
              className='tw-mt-2'
            />
          </m.div>

          <Bubble m={m} step='AGENT_1' sentences={["Hey, you've reached our Support Team.", "How can I help you?"]} />
          <Bubble
            m={m}
            step='USER_1'
            sentences={["I just got charged extra customs on your parcel – yesterday's order was fine. What changed?"]}
            variant='user'
            className='tw-mt-2'
            delay={1}
          />
          <Bubble
            m={m}
            step='AGENT_2'
            sentences={[
              "I don't have up-to-date information on customs policies.",
              "Let me redirect you to a human agent who can look into this.",
            ]}
            className='tw-mt-2'
            delay={1}
          />
        </>
      )}
    </ChatGuardrailsContainer>
  );
}
